import { createActions } from 'reduxsauce';

var _createActions = createActions({
  changeInput: function changeInput(e) {
    var obj = {
      type: 'NEWSLETTER_CHANGE_INPUT'
    };
    obj[e.target.name] = e.target.value;
    return obj;
  },
  request: function request() {
    return {
      type: 'NEWSLETTER_REQUEST'
    };
  },
  response: function response(json) {
    return {
      type: 'NEWSLETTER_RESPONSE',
      results: json,
      receivedAt: Date.now()
    };
  },
  error: function error() {
    return {
      type: 'NEWSLETTER_ERROR'
    };
  }
}, {
  prefix: 'NEWSLETTER_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};